<app-header></app-header>
<div class="unauth-class">
    {{message}}
</div>